const MockSvgElement = () => {
  return <svg data-test-id='mock-svg' />
}

export default MockSvgElement
